export interface DropDownOption {
    value: number;
    label: string;
    imgUrl: string;
}

export const onlyUnique = <V, I>(value: V, index: I, self: V[]) => {
    return self.indexOf(value) === index;
};